import { LayoutDashboard, LogOut, Package2, ShieldCheck, ShoppingCart, UserCog, UserRound } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { NAV_LINKS } from '../../constants/appConfig';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { formatRole } from '../../utils/formatters';

function resolveIcon(label) {
  switch (label) {
    case 'Productos':
      return <Package2 size={16} />;
    case 'Mi Perfil':
      return <UserRound size={16} />;
    case 'Dashboard':
      return <LayoutDashboard size={16} />;
    case 'Admin':
      return <UserCog size={16} />;
    default:
      return null;
  }
}

export default function Navbar() {
  const { isAuthenticated, logout, openAuthModal, profile, session } = useAuth();
  const { totalItems, openCart } = useCart();
  const navLinks =
    session?.role === 'ADMIN'
      ? [...NAV_LINKS, { to: '/dashboard', label: 'Dashboard' }, { to: '/admin', label: 'Admin' }]
      : NAV_LINKS;

  return (
    <header className="main-header">
      <div className="main-header__inner">
        <NavLink className="brand-lockup" to="/">
          <div className="brand-mark">
            <img src="/logo.png" alt="OG Canna" />
          </div>
          <div>
            <p className="brand-lockup__eyebrow">OG Canna</p>
            <strong>{profile?.name || session?.username || 'Premium Store'}</strong>
          </div>
        </NavLink>

        <nav className="main-nav">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              className={({ isActive }) => `main-nav__link${isActive ? ' is-active' : ''}`}
              to={link.to}
            >
              {resolveIcon(link.label)}
              <span>{link.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="main-header__actions">
          <button className="cart-button" type="button" aria-label="Ver carrito" onClick={openCart}>
            <ShoppingCart size={18} />
            {totalItems > 0 && <span>{totalItems}</span>}
          </button>

          {!isAuthenticated ? (
            <button className="button button--ghost" type="button" onClick={() => openAuthModal('login')}>
              <UserRound size={16} />
              <span>Acceder</span>
            </button>
          ) : (
            <>
              <div className="session-chip">
                <ShieldCheck size={14} />
                <span>{formatRole(session?.role)}</span>
              </div>
              <button className="button button--ghost" type="button" onClick={logout}>
                <LogOut size={16} />
                <span>Salir</span>
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}